export const importFromCsv = {
  title: 'CSV Import Tank',
  importSuccessfully: 'Import tank successfully!',
  importFailed: 'Import tank failed!',
}
